import React from 'react';
import PropTypes from 'prop-types';
// project import
import Navigation from './Navigation';
import SimpleBar from '../../../../../view-components/cards/SimpleBar';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';

// ==============================|| DRAWER CONTENT ||============================== //

const DrawerContent = ({ handleDrawerToggle }) => (
    <SimpleBar
        sx={{
            '& .simplebar-content': {
                display: 'flex',
                flexDirection: 'column'
            }
        }}
    >
        <Navigation handleDrawerToggle={handleDrawerToggle} />
        <Typography variant="body2" color="text.secondary" align="center">
            {'Copyright © '}
            <Link color="inherit" href="https://stations.com/">
                stations
            </Link>{' '}
            {new Date().getFullYear()}
        </Typography>
    </SimpleBar>
);

DrawerContent.propTypes = {
    handleDrawerToggle: PropTypes.func
};

export default DrawerContent;
